"use client";

import { cx } from "./style.utils";

function Table({
  children,
  className,
  ...props
}: React.ComponentProps<"table">) {
  return (
    <div
      data-slot="table-container"
      className="relative w-full overflow-x-auto"
    >
      <table
        data-slot="table"
        className={cx("w-full caption-bottom bg-white text-sm", className)}
        {...props}
      >
        {children}
      </table>
    </div>
  );
}

function TableHeader({
  children,
  className,
  ...props
}: React.ComponentProps<"thead">) {
  return (
    <thead
      data-slot="table-header"
      className={cx(
        "bg-shade-2 [&_tr]:border-b [&_tr]:border-b-shade-15",
        className,
      )}
      {...props}
    >
      {children}
    </thead>
  );
}

function TableBody({
  children,
  className,
  ...props
}: React.ComponentProps<"tbody">) {
  return (
    <tbody
      data-slot="table-body"
      className={cx("[&_tr:last-child]:border-0", className)}
      {...props}
    >
      {children}
    </tbody>
  );
}

function TableFooter({
  children,
  className,
  ...props
}: React.ComponentProps<"tfoot">) {
  return (
    <tfoot
      data-slot="table-footer"
      className={cx(
        "border-t border-t-shade-15 bg-shade-8 font-semibold [&>tr]:last:border-b-0",
        className,
      )}
      {...props}
    >
      {children}
    </tfoot>
  );
}

function TableRow({
  children,
  className,
  ...props
}: React.ComponentProps<"tr">) {
  return (
    <tr
      data-slot="table-row"
      className={cx(
        "border-b border-b-shade-15",
        "data-[state=selected]:bg-primary-10 [tbody>&:not([data-state=selected])]:hover:bg-shade-2",
        className,
      )}
      {...props}
    >
      {children}
    </tr>
  );
}

function TableHead({
  children,
  className,
  ...props
}: React.ComponentProps<"th">) {
  return (
    <th
      data-slot="table-head"
      className={cx(
        "whitespace-nowrap p-10px text-left align-middle font-semibold first:pl-30px last:pr-30px",
        "[&:has([role=checkbox])]:w-16px [&>[role=checkbox]]:translate-y-[2px]",
        className,
      )}
      {...props}
    >
      {children}
    </th>
  );
}

function TableCell({
  children,
  className,
  ...props
}: React.ComponentProps<"td">) {
  return (
    <td
      data-slot="table-cell"
      className={cx(
        "whitespace-nowrap p-10px align-middle first:pl-30px last:pr-30px",
        "[&:has([role=checkbox])]:w-16px [&>[role=checkbox]]:translate-y-[2px]",
        className,
      )}
      {...props}
    >
      {children}
    </td>
  );
}

function TableCaption({
  children,
  className,
  ...props
}: React.ComponentProps<"caption">) {
  return (
    <caption
      data-slot="table-caption"
      className={cx("mt-16px text-sm", className)}
      {...props}
    >
      {children}
    </caption>
  );
}

export {
  Table,
  TableBody,
  TableCaption,
  TableCell,
  TableFooter,
  TableHead,
  TableHeader,
  TableRow,
};
